import * as snippet from '@segment/snippet';
import { User } from '@auth0/auth0-spa-js';
import { Router } from 'next/router';
import {
  isProductionEnvironment,
  SEGMENT_API_KEY,
} from '@/environment';

export * as analytics from './__GENERATED__/';

export function identifyAuth0User(user: User): void {
  analytics.identify(user['https://growflow.com/app_metadata/global/analytics_userid'], {
    email: user.email!,
  });
}

export function trackRouteChanges(): void {
  Router.events.on('routeChangeComplete', (url: String) => {
    analytics.page(url);
  });
}

export function getAnalyticsSnippet(): string {
  const opts = { apiKey: SEGMENT_API_KEY };

  if (isProductionEnvironment) {
    return snippet.min(opts);
  }

  return snippet.max(opts);
}
